export const AGENT_SECRET_KEY = "00e9247dc611c5c3be3d6bc05b64a3a68354e5a31bfe7595baf66ce4b2de787f"; 
// export const AGENT_SECRET_KEY = "57c33531f752b1e193bc22a835ff1d8e2a4587cca0067384feb300016acb0ed6"; // Agent 2 